import SearchDateController from "./search_date_controller"
import SearchGuestsController from "./search_guests_controller"

import DrawerController from "../drawer_controller"
import ModalController from "../modal_controller"

export default class extends ModalController {
  static outlets = ["drawer", "search-date", "search-guests"]
  declare readonly drawerOutlets: DrawerController[]
  declare readonly searchDateOutlet: SearchDateController
  declare readonly searchGuestsOutlet: SearchGuestsController

  static targets = ["calendarHeader"]
  declare readonly calendarHeaderTarget: HTMLElement

  clearAll(): void {
    this.searchDateOutlet.deselectDate()
    this.searchGuestsOutlet.resetGuests()
    this.drawerOutlets.forEach((drawer) => drawer.close())
  }

  protected performOpen(): void {
    super.performOpen()

    // Set custom prop for calendar scroll offset from sticky header, plus gap.
    this.element.style.setProperty(
      "--search-modal-date-offset",
      `${this.calendarHeaderTarget.getBoundingClientRect().height + 16}px`
    )

    if (!this.hasOpenDrawer) {
      // Set custom prop for calendar height offset to one drawer's height, plus gap.
      this.element.style.setProperty(
        "--search-modal-height-offset",
        `${this.drawerOutlets.at(0)!.element.getBoundingClientRect().height + 16 * 2}px`
      )

      // Open first drawer that's missing a value.
      if (!this.searchDateOutlet.isDateSelected) {
        this.searchDateOutlet.openDateDrawer()
      } else if (this.searchGuestsOutlet.isZeroSelected) {
        this.searchGuestsOutlet.openGuestsDrawer()
      }
    }
  }

  openAndFocusDate(): void {
    this.open()
    this.searchDateOutlet.openDateDrawer()
  }

  private get hasOpenDrawer(): boolean {
    return !!this.drawerOutlets.find((drawer) => drawer.openValue)
  }
}
